var render = function render(){var _vm=this,_c=_vm._self._c;return _c('note-list',{attrs:{"is-fetching":_vm.uiFlags.isFetching,"notes":_vm.notes},on:{"add":_vm.onAdd,"delete":_vm.onDelete}})
}
var staticRenderFns = []

export { render, staticRenderFns }